import { BUSINESS_SOLUTION_ORGANIZATION_ID } from '@app/access/constants/organizations';
import { Error403Unauthorized } from '@app/components';
import { config } from '@app/config';
import { FORBIDDEN_ERROR_MAIN_PART, PREFIX } from '@app/constants';
import { useAccessToOrganizations, useUserPrint } from '@app/hooks';

export const OrganizationAiSettings = () => {
  const { database } = useUserPrint();
  const { areRightsToOrganizationsModule } = useAccessToOrganizations();

  const hasAccess =
    config.mode === 'production'
      ? database === BUSINESS_SOLUTION_ORGANIZATION_ID
      : areRightsToOrganizationsModule;

  if (!hasAccess) {
    return <Error403Unauthorized title={`${FORBIDDEN_ERROR_MAIN_PART}.`} />;
  }

  return (
    <div className={`${PREFIX}organization-ai-settings`}>
      Настройка ИИ в разработке
    </div>
  );
};
